export default __webpack_public_path__ + "static/media/tf.5743c8d5.png";